export const videos = [
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/1_MauroLajo_14064_IntroCorso.mp4',
    thumb: 'images/thumb-video-1.png',
    show: false,
    title: 'Introduzione al Corso',
    description:
      'In questo video si presenta il corso, illustrando gli obiettivi, la struttura e il percorso formativo che seguirà.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/2_MauroLajo_14064_IntroAgliInventari.mp4',
    thumb: 'images/thumb-video-2.png',
    show: false,
    title: 'Introduzione agli Inventari',
    description:
      "Mauro introduce il concetto di inventari, spiegandone l'importanza e il ruolo nella gestione ambientale e nella misurazione delle emissioni."
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/3_MauroLajo_14064_InventariCapitoli1-4.mp4',
    thumb: 'images/thumb-video-3.png',
    show: false,
    title: 'Inventari - Capitoli 1-4',
    description:
      'Il video affronta i primi quattro capitoli del modulo sugli inventari, evidenziando le metodologie, le normative e le tecniche di raccolta dati.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/4_MauroLajo_14064_InventariCapitolo5.mp4',
    thumb: 'images/thumb-video-4.png',
    show: false,
    title: 'Inventari - Capitolo 5',
    description:
      "Focus sul quinto capitolo degli inventari, con un approfondimento sui processi specifici e l'analisi dei casi pratici."
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/5_MauroLajo_14064_InventariEsercitazione1.mp4',
    thumb: 'images/thumb-video-5.png',
    show: false,
    title: 'Esercitazione sugli Inventari 1',
    description:
      'Sessione pratica per applicare i concetti degli inventari, con esercizi mirati per consolidare le conoscenze apprese.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/6_MauroLajo_14064_InventariCapitolo5-2.mp4',
    thumb: 'images/thumb-video-6.png',
    show: false,
    title: 'Inventari - Approfondimenti Capitolo 5',
    description:
      'Ulteriori spiegazioni e dettagli sul Capitolo 5, con esempi pratici e discussioni interattive per chiarire i concetti complessi.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/7_MauroLajo_14064_CategorieEmissioni1-3.mp4',
    thumb: 'images/thumb-video-7.png',
    show: false,
    title: 'Categorie di Emissioni - Parte 1-3',
    description:
      'Analisi delle prime tre categorie di emissioni, illustrando le fonti, le caratteristiche e i criteri di classificazione utilizzati.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/8_MauroLajo_14064_CategorieEmissioni4-6.mp4',
    thumb: 'images/thumb-video-8.png',
    show: false,
    title: 'Categorie di Emissioni - Parte 4-6',
    description:
      'Continuazione dello studio sulle categorie di emissioni, con approfondimenti sui processi di controllo e le tecnologie per la mitigazione.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/9_MauroLajo_14064_Esercitazione2.mp4',
    thumb: 'images/thumb-video-9.png',
    show: false,
    title: 'Esercitazione sugli Inventari ed Emissioni 2',
    description:
      'Esercitazione pratica che integra le tematiche degli inventari e delle emissioni, con esempi di applicazione concreta.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/10_MauroLajo_14064_EmissioniGHGSignificative.mp4',
    thumb: 'images/thumb-video-10.png',
    show: false,
    title: 'Emissioni GHG Significative',
    description:
      'Analisi delle emissioni significative di gas a effetto serra (GHG), con attenzione ai fattori critici e alle strategie di riduzione.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/11_MauroLajo_14064_Esercitazione3.mp4',
    thumb: 'images/thumb-video-11.png',
    show: false,
    title: 'Esercitazione Pratica 3',
    description:
      "Sessione formativa dedicata all'applicazione dei concetti di inventario e analisi delle emissioni, con esercizi di calcolo e valutazione."
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/12_MauroLajo_14064_QuantificazioneERimozioniGHG_Parte1.mp4',
    thumb: 'images/thumb-video-12.png',
    show: false,
    title: 'Quantificazione e Rimozioni GHG - Parte 1',
    description:
      'Introduzione alle tecniche di quantificazione delle emissioni e alle strategie per la rimozione dei gas a effetto serra, prima parte del modulo.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/13_MauroLajo_14064_Esercitazione4.mp4',
    thumb: 'images/thumb-video-13.png',
    show: false,
    title: 'Esercitazione Pratica 4',
    description:
      'Ulteriore esercitazione pratica finalizzata a consolidare le competenze acquisite, applicando metodologie e strumenti analitici.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/14_MauroLajo_14064_QuantificazioneERimozioniGHG_Parte2.mp4',
    thumb: 'images/thumb-video-14.png',
    show: false,
    title: 'Quantificazione e Rimozioni GHG - Parte 2',
    description:
      'Proseguimento del modulo sulla quantificazione e rimozione dei GHG, con approfondimenti tecnici e casi studio avanzati.'
  },
  {
    url:
      'https://dk670cfuasfcb.cloudfront.net/15_MauroLajo_14064_RapportoInventarioEComunicazione.mp4',
    thumb: 'images/thumb-video-15.png',
    show: false,
    title: "Rapporto d'Inventario e Comunicazione",
    description:
      "Il video illustra come redigere il rapporto d'inventario, evidenziando le migliori pratiche per la comunicazione dei risultati e il rispetto delle normative ambientali."
  }
];
